export const ROOT = '/blacklist';
export const MODULE = 'BLACKLIST';
